<script>
import {classify} from '../data'

export default {
  name: 'TechnologyTab',
  props: {
    value: {
      type: String | Number,
      required: true
    }
  },
  data() {
    return {
      classify
    }
  },
  methods: {
    handleClick(item) {
      if (this.$parent.$refs.TechnologyList.listState.loading) return
      this.$emit('input', item.value)
    }
  }
}
</script>

<template>
  <div class="tabs">
    <div class="tabs-item" v-for="item in classify" :key="item.nanoid"
         v-track="{ functionName: `新技术-${item.label}`}" @click="handleClick(item)">
      <div class="tabs-item-icon">
        <img
          class="icon"
          :class="value === item.value ? 'active' : ''"
          :src="value === item.value ? item.activeIconPath : item.iconPath"
          alt=""/>
        <img
          class="bg"
          :class="value === item.value ? 'active' : ''"
          :src="value === item.value ? item.activeIconBgPath : item.iconBgPath"
          alt="">
      </div>
      <div class="tabs-item-label" :class="{ 'active': item.value === value }">{{ item && item.label }}</div>
    </div>
  </div>
</template>

<style scoped lang="less">
.tabs {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  margin: 15px 15px 0;

  .tabs-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tabs-item-icon {
      position: relative;
      display: flex;
      width: 45px;
      height: 40px;
      justify-content: center;

      .icon {
        position: absolute;
        z-index: 2;
        bottom: 6px;
        width: 24px;

        &.active {
          width: 29px;
        }
      }

      .bg {
        position: absolute;
        z-index: 1;
        bottom: 0;
        width: 35px;
        height: 15px;

        &.active {
          width: 45px;
          height: 15px;
        }
      }
    }

    .tabs-item-label {
      font-family: Alibaba PuHuiTi 3.0;
      font-size: 10px;
      color: #6C7480;
      margin-top: 5px;

      &.active {
        font-size: 12px;
        font-weight: bold;
        color: #3D3D3D;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/technology/modules/TechnologyTab.vue